import { defineMessages } from 'react-intl';

export default defineMessages({
    addingDriver: {
        id: 'wmic-pe-capability-gateway-common-pa-react.hooks.useDriverActions.Adding driver...',
        defaultMessage: 'Adding driver...',
    },
    licenceMatchMsg: {
        id: 'wmic-pe-capability-gateway-common-pa-react.hooks.useDriverActions.LicenceMatchMsg',
        defaultMessage:
            'Sorry, but this drivers license number matches that of {driver}. Please ensure that all licence numbers are unique.',
    },
    licenseNotUnique: {
        id: 'wmic-pe-capability-gateway-common-pa-react.hooks.useDriverActions.Licence number is not unique',
        defaultMessage: 'Licence number is not unique',
    },
    removeDriver: {
        id: 'wmic-pe-capability-gateway-common-pa-react.hooks.useDriverActions.removeDriver',
        defaultMessage: 'Are you sure you want to remove {driver} from the list of drivers?',
    },
    removeDriverTitle: {
        id: 'wmic-pe-capability-gateway-common-pa-react.hooks.useDriverActions.Remove driver?',
        defaultMessage: 'Remove driver?',
    },
    removingDriver: {
        id: 'wmic-pe-capability-gateway-common-pa-react.hooks.useDriverActions.Removing driver...',
        defaultMessage: 'Removing driver...',
    },
    removingDriverErrorModalTitle: {
        id: 'wmic-pe-capability-gateway-common-pa-react.hooks.useDriverActions.removing-driver.errorModalTitle',
        defaultMessage: 'Error',
    },
    savingDriver: {
        id: 'wmic-pe-capability-gateway-common-pa-react.hooks.useDriverActions.Saving driver...',
        defaultMessage: 'Saving driver...',
    },
});
